export default "__VITE_ASSET__1cdaeeee__"